module.exports = __webpack_public_path__ + "static/media/kababButton.c59311d0.svg";